import { render, staticRenderFns } from "./PrefeiturasTabela.vue?vue&type=template&id=6ff637f2"
import script from "./PrefeiturasTabela.vue?vue&type=script&lang=js"
export * from "./PrefeiturasTabela.vue?vue&type=script&lang=js"
import style0 from "./PrefeiturasTabela.vue?vue&type=style&index=0&id=6ff637f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports